import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  useTheme,
} from '@mui/material';
import {
  BarChart as BarChartIcon,
  AccountBalance as AccountBalanceIcon,
  FileDownload as FileDownloadIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const actions = [
    {
      label: 'View Campaign Performance',
      icon: <BarChartIcon />,
      onClick: () => navigate('/reports'),
      disabled: false,
    },
    {
      label: 'Manage Ad Budgets',
      icon: <AccountBalanceIcon />,
      onClick: () => navigate('/reports'),
      disabled: false,
    },
    {
      label: 'Export Data (Soon)',
      icon: <FileDownloadIcon />,
      onClick: () => {},
      disabled: true,
    },
  ];

  return (
    <Card
      sx={{
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(146,153,184,0.15)',
        border: 'none',
      }}
    >
      <CardContent sx={{ padding: '25px !important' }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            mb: 3,
          }}
        >
          Quick Actions
        </Typography>

        <Grid container spacing={2}>
          {actions.map((action, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Button
                variant="outlined"
                fullWidth
                startIcon={action.icon}
                onClick={action.onClick}
                disabled={action.disabled}
                sx={{
                  py: 1.5,
                  justifyContent: 'flex-start',
                  borderColor: theme.palette.divider,
                  '&:hover': {
                    borderColor: theme.palette.primary.main,
                    bgcolor: `${theme.palette.primary.main}08`,
                  },
                }}
              >
                {action.label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
